import {
  BFMultiProgressBar,
  type ProgressSegment,
} from "@/components/BFMultiProgressbar"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Body, H3, H5, H6, Small } from "@/components/standard/BFText"
import React from "react"
import { View } from "react-native"
import CheckCircle from "phosphor-react-native/src/icons/CheckCircle"
import ClockCountdown from "phosphor-react-native/src/icons/ClockCountdown"
import { formatCurrency } from "@/screens/draws/utils"
import { BFColors } from "@/constants/Colors"
import { Separator } from "@/components/reusables/ui/separator"

export const DrawsSummary = ({
  budgetedLeft,
  budgetedTotal,
  completedDrawsTotal,
  pendingDrawsTotal,
}: {
  budgetedLeft: number
  budgetedTotal: number
  completedDrawsTotal: number
  pendingDrawsTotal: number
}) => {
  const segments: ProgressSegment[] = [
    {
      value: completedDrawsTotal,
      color: BFColors.teal,
    },
    {
      value: pendingDrawsTotal,
      color: BFColors.lightGrey,
    },
    {
      value: budgetedTotal - (completedDrawsTotal + pendingDrawsTotal),
      color: BFColors.calmBlue,
    },
  ]

  return (
    <Vertical className="gap-5">
      <View>
        <Horizontal className="flex-row mb-2 justify-between items-end">
          {budgetedLeft > 0 ? (
            <Horizontal className={"items-center"}>
              <View className="size-5 bg-calm-blue rounded mr-2" />
              <Horizontal className={"items-end"}>
                <H3 className="text-foreground">
                  {formatCurrency(budgetedLeft)}
                </H3>
                <Body className="pl-1 text-muted-foreground">left</Body>
              </Horizontal>
            </Horizontal>
          ) : (
            <Horizontal className={"items-center"}>
              <H3 className="text-foreground">Fully funded!</H3>
            </Horizontal>
          )}

          <Horizontal className={"items-center self-end"}>
            {budgetedLeft > 0 && <Small>of </Small>}
            <H6>{formatCurrency(budgetedTotal)}</H6>
          </Horizontal>
        </Horizontal>
        <BFMultiProgressBar segments={segments} className={"h-4"} />
      </View>

      <Separator className={"w-full"} />

      {budgetedLeft > 0 ? (
        <View className="flex-row gap-5">
          <Horizontal className="flex-1 items-center justify-between">
            <Horizontal className="gap-1">
              <CheckCircle size={14} />
              <H6>Drawn</H6>
            </Horizontal>
            <H6 className={"bg-teal rounded-sm p-2"}>
              {formatCurrency(completedDrawsTotal)}
            </H6>
          </Horizontal>
          <Separator orientation={"vertical"} />
          <Horizontal className="flex-1 items-center justify-between">
            <Horizontal className="gap-1">
              <ClockCountdown size={14} />
              <H6>Pending</H6>
            </Horizontal>
            <H6 className={"bg-light-grey rounded-sm p-2"}>
              {formatCurrency(pendingDrawsTotal)}
            </H6>
          </Horizontal>
        </View>
      ) : (
        <Vertical className="gap-2">
          <H5 color="primary" className="text-center">
            Your funding is complete!
          </H5>
          <Body color="primary" className="text-center">
            We can’t wait to help with your next flip
          </Body>
        </Vertical>
      )}
    </Vertical>
  )
}
